import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { format } from 'date-fns';

interface EmspBoTariffUpdatedAfterFilterStateControllerProps {
  value: Date | string;
  onRemove: FilteredItemProps['onRemove'];
}

export const EmspBoTariffUpdatedAfterFilterStateController = ({
  value,
  onRemove,
}: EmspBoTariffUpdatedAfterFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const updatedAt = format(value, 'yyyy-MM-dd');

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem icon="calendar-date" label={updatedAt} onRemove={onRemove} />
  );
};
